import { render, staticRenderFns } from "./unrelevance1.vue?vue&type=template&id=479679cf&scoped=true"
import script from "./unrelevance1.vue?vue&type=script&lang=js"
export * from "./unrelevance1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479679cf",
  null
  
)

export default component.exports